module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "pages"
  }, [_c('sub-ibox-title', [_c('p', {
    attrs: {
      "slot": "title"
    },
    slot: "title"
  }, [_vm._v("满减活动详情")])]), _vm._v(" "), _c('section', {
    staticClass: "content"
  }, [_c('ul', {
    staticClass: "promotion-ditail"
  }, [_c('li', {
    staticClass: "fx"
  }, [_c('p', [_vm._v("活动名称")]), _c('div', [_vm._v(_vm._s(_vm.info.name))])]), _vm._v(" "), _c('li', {
    staticClass: "fx"
  }, [_c('p', [_vm._v("创建时间")]), _c('div', [_vm._v(_vm._s(_vm.info.c_time))])]), _vm._v(" "), _c('li', {
    staticClass: "fx"
  }, [_c('p', [_vm._v("开始时间")]), _c('div', [_vm._v(_vm._s(_vm.info.start_time))])]), _vm._v(" "), _c('li', {
    staticClass: "fx"
  }, [_c('p', [_vm._v("结束时间")]), _c('div', [_vm._v(_vm._s(_vm.info.end_time))])]), _vm._v(" "), _c('li', {
    staticClass: "fx"
  }, [_c('p', [_vm._v("门槛条件")]), _vm._v(" "), _c('ol', [_c('li', _vm._l((_vm.info.condition), function(item) {
    return _c('div', [_vm._v("满" + _vm._s(_vm._f("filterMoney")(item.least_cost)) + "元 减 " + _vm._s(_vm._f("filterMoney")(item.reduce_cost)) + "元")])
  }), 0)])]), _vm._v(" "), _c('li', {
    staticClass: "fx"
  }, [_c('p', [_vm._v("适用门店")]), _vm._v(" "), _c('div', [_c('ol', _vm._l((_vm.info.shop_list || []), function(items) {
    return _c('li', [_vm._v(_vm._s(items.name))])
  }), 0)])])])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/_vue-loader@12.2.2@vue-loader/lib/template-compiler?{"id":"data-v-dafdb11a","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/_vue-loader@12.2.2@vue-loader/lib/selector.js?type=template&index=0!./src/views/mp/marketing/promotions/PromotionInfoPage.vue
// module id = 887
// module chunks = 0